export default [
  '$q',
  'CurrencyAPIService',
  'ErrorHandler',
  class CurrencyService {
    constructor($q, CurrencyAPISerice, errorHandler) {
      this._$q = $q;
      this._currencyAPIService = CurrencyAPISerice;
      this._errorHandler = errorHandler;

      // default currency info to USD
      this.info = this._defaultInfo();

      this.currencyInit = false;
    }

    init(country) {
      let deferred = this._$q.defer();

      if (!this.currencyInit) {
        this._currencyAPIService.getCurrencyInfo(country)
          .then((res) => {
            this.info = res;
            deferred.resolve(res);
          })
          .catch((err) => {
            if (err.status == 500) {
              this._errorHandler.logError('Currency Error', 'An error was encountered while attempting to fetch currency information.', {
                rawError: err
              });
            }
            this.info = this._defaultInfo();
            deferred.reject();
          });

        this.currencyInit = true;
      } else {
        deferred.resolve(this.info);
      }

      return deferred.promise;
    }

    setCountry(country) {
      if (country !== this.info.country_code) {
        this.currencyInit = false;
        this.init(country);
      }
    }

    _defaultInfo() {
      return {
        conversion_rate: 1,
        iso_code: "USD",
        currency_symbol: "$",
        country_code: "US"
      };
    }
  }
]



// WEBPACK FOOTER //
// ./source/client/data-providers/currency-service.js